/// <amd-module name="SuiteCommerce.Blog.Post.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Collection", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Post.Model", "underscore"], function (require, exports, Backbone_1, Post_Model_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostCollection = /** @class */ (function (_super) {
        __extends(PostCollection, _super);
        function PostCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = Post_Model_1.PostModel;
            _this.url = '/app/site/hosting/scriptlet.nl?script=customscript_ns_sc_sl_blog_post_searcher' +
                '&deploy=customdeploy_ns_sc_sl_blog_post_searcher';
            _this.totalInServer = 0;
            return _this;
        }
        PostCollection.prototype.parse = function (response) {
            this.totalInServer = response.total;
            return _(response.data).compact() || null;
        };
        return PostCollection;
    }(Backbone_1.Collection));
    exports.PostCollection = PostCollection;
});
